import { Component, OnInit, Output, EventEmitter, ViewChild } from "@angular/core";
import { TranslateService } from '@ngx-translate/core';
import { SelectItem } from "primeng/primeng";
import * as _ from 'lodash';

import { DynamicListService } from '../../../../shared/service/dynamic-list.service';
import { ListService } from '../../../../shared/service/list.service';

import { UnconformityModalComponent } from "./unconformity-modal/unconformity-modal.component";
import { MessageComponent } from '../../../../shared/component/message/message.component';
import { EvaluativeTypesTranslation } from "../../../../shared/enum/evaluative-type";
import { OperationTypesTranslation } from '../../../../shared/enum/operation-types';
import { QuestionTypesTranslation } from "../../../../shared/enum/question-type";
import { UnconformityModel } from "../../../../shared/model/unconformity.model";
import { DynamicListModel } from '../../../../shared/model/dynamic-list.model';
import { QuestionModel } from "../../../../shared/model/question.model";
import { ListModel } from '../../../../shared/model/list.model';

@Component({
	selector: "app-question-form-modal",
	templateUrl: "./question-form-modal.component.html",
	styleUrls: ["./question-form-modal.component.css"],
})
export class QuestionFormModalComponent implements OnInit {
	@ViewChild(UnconformityModalComponent) unconformityModal: UnconformityModalComponent;
	@ViewChild(MessageComponent) message: MessageComponent;
	@Output() save = new EventEmitter<QuestionModel>();

	question: QuestionModel = new QuestionModel();
	evaluativeTypes: SelectItem[] = [];
	operationTypes: SelectItem[] = [];
	questionTypes: SelectItem[] = [];
	orderLimit: number
	display: boolean;
	
  selectedOrdenation = '';
  selectedMethod = '';
	chooseListWord = '';

	dynamicLists: DynamicListModel[] = [];
	lists: ListModel[] = [];

	dynamicListOptions: SelectItem[] = [];
	listOptions: SelectItem[] = [];

	// Auxiliars

  pagination = { init: 0, end: 1e8 };

  ascDesc = [
    { value: 'asc', label: "Ascendente" },
    { value: 'desc', label: "Decrescente" },
  ];

  ordenation = [
    { value: 'id', label: "Data de Criação" },
    { value: 'name', label: "Ordem Alfabetica" },
  ];

	constructor(
		private translateService: TranslateService,
		private dynListService: DynamicListService,
		private listService: ListService
	) {
		this.buildDropdownOptions();
	}

	ngOnInit() { }

	getListName(question: QuestionModel) {
		const { list_id, dyn_list_id } = question;

		if (question) {
			if (list_id) {
				const list = this.listOptions.find(({ value }) => value == list_id);
				if (list) return list.label;
			}

			if (dyn_list_id) {
				const list = this.dynamicListOptions.find(({ value }) => value == dyn_list_id);
				if (list) return list.label;
			}
		}

		return this.chooseListWord;
	}

	saveUnconformities(event: UnconformityModel[]) {
		this.question.unconformities = event;
		this.unconformityModal.display = false;
		if(this.question.question_type === 1) {
			this.question.default_response = !this.question.default_response ? null : '1' 
		}
		// this.save.emit(this.question);
	}

	openUnconformityModal() {
		this.unconformityModal.display = true;
	}

	saveQuestion() {
		if(this.question.question_type === 1) {
			this.question.default_response = !this.question.default_response ? null : '1' 
		}

		const hasError = this.validateQuestion();
		if (hasError) return this.message.error(hasError);

		this.save.emit(this.question);
	}

	onCloseModal() {
		this.question = new QuestionModel();
	}

	onOpenModal() {
		this.buildLists();
		this.buildDynamicLists();
	}

	// prevent saving of invalid question
	validateQuestion(): string | undefined {
		if (
			this.question.question_type == QuestionTypesTranslation['boolean'] ||
			this.question.question_type == QuestionTypesTranslation['criticality']
		) {
			if (!this.question.unconformities || !this.question.unconformities.length) {
				return 'select_unconformity';
			}
		}

		if (this.question.question_type == QuestionTypesTranslation['operation']) {
			if (!this.question.operation_type || !this.question.operation_value) {
				return 'need_more_data';
			}
		}

		if (this.question.question_type == QuestionTypesTranslation['simple_list']) {
			if (!this.question.list_id || this.question.list_id == -1) {
				return 'list_not_selected';
			}
		}

		if (this.question.question_type == QuestionTypesTranslation['dynamic_list']) {
			if (!this.question.dyn_list_id || this.question.dyn_list_id == -1) {
				return 'list_not_selected';
			}
		}

		if (this.question.question_type == QuestionTypesTranslation['evaluative']) {
			if (!this.question.evaluative_type || this.question.evaluative_type == -1) {
				return 'select_evaluative_type';
			}
		}

	}

	resetCustomFields() {
		this.question.okay_description = null;
		this.question.disapproved_description = null;
		this.question.quantitative_description = null;
		this.question.descriptive_limit = 256;
		this.question.evaluative_type = null;
	}

	buildDropdownOptions() {
		let questionTypes: number[] = [];
		let operationTypes: number[] = [];
		let evaluationTypes: number[] = [];

		for (let type in QuestionTypesTranslation) {
			if (!isNaN(parseInt(type))) {
				questionTypes.push(parseInt(type));
			}
		}

		for (let type in EvaluativeTypesTranslation) {
			if (!isNaN(parseInt(type))) {
				evaluationTypes.push(parseInt(type));
			}
		}

		for (let type in OperationTypesTranslation) {
			if (!isNaN(parseInt(type))) {
				operationTypes.push(parseInt(type));
			}
		}

		this.translateService.get('select_question_type').subscribe(_ => {
			questionTypes.forEach(value => {
				const realName = QuestionTypesTranslation[value];
				const label = this.translate(realName);

				this.questionTypes.push({ label, value });
			});

			evaluationTypes.forEach(value => {
				const realName = EvaluativeTypesTranslation[value];
				const label = this.translate(realName);

				this.evaluativeTypes.push({ label, value });
			});

			operationTypes.forEach(value => {
				const realName = OperationTypesTranslation[value];
				const label = this.translate(realName);

				this.operationTypes.push({ label, value });
			});

			this.chooseListWord = this.translate('choose_list');
		})
	}

	buildLists() {
		this.listOptions = [];

		this.listService.getPaginated(0, 1000).subscribe(result => {
			const lists = result['rows'] as ListModel[];
			this.lists = lists;

			lists.forEach(({ id: value, name: label }) => {
				this.listOptions.push({ value, label });
			})
		});
	}

	buildDynamicLists() {
		this.dynamicListOptions = [];

		this.dynListService.getPaginated(this.pagination).subscribe(result => {
			const dynamicLists = result['rows'] as DynamicListModel[];
			this.dynamicLists = dynamicLists;

			dynamicLists.forEach(({id: value, name: label }) => {
				this.dynamicListOptions.push({ value, label });
			})
		});
	}

	order() {
		this.listOptions = [];
		this.dynamicListOptions = [];

		const sortedLists = _.orderBy(this.lists, this.selectedOrdenation, this.selectedMethod);
		const sortedDynLists = _.orderBy(this.dynamicLists, this.selectedOrdenation, this.selectedMethod);

		sortedLists.forEach(({ id: value, name: label }) => {
			this.listOptions.push({ value, label });
		});

		sortedDynLists.forEach(({ id: value, name: label }) => {
			this.dynamicListOptions.push({ value, label });
		});
	}

	translate = (key: string) => this.translateService.instant(key || "invalid");
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/checklist-form/question-group/question/question-form-modal/question-form-modal.component.ts